import React from 'react';
import PropTypes from 'prop-types';

import { ConditionalQuestionLabel } from 'components/ConditionalQuestion';
import generateQuestionFormName from 'utils/generateQuestionFormName';

import DropdownQuestionForm from './DropdownQuestionForm';
import { questionLayoutPropType } from '../../../config/richTextConfig/questionLayout';
import TextQuestionRichText from '../../../domains/richText/components/TextQuestionRichText';
import convertFromPlainAnswer from '../utils/convertFromPlainAnswer';
import convertToPlainAnswer from '../utils/convertToPlainAnswer';
import propTypeBlockStyling from '../../../domains/styling/config/editorBlock/PropTypes/blockStyling';

class DropdownQuestion extends React.Component {
  static propTypes = {
    block: PropTypes.shape({
      clientUuid: PropTypes.string.isRequired,
      required: PropTypes.bool,
      content: PropTypes.object,
    }).isRequired,
    isCloned: PropTypes.bool,
    isInPreviewMode: PropTypes.bool,
    layout: questionLayoutPropType,
    onAnswer: PropTypes.func.isRequired,
    answer: PropTypes.shape({
      value: PropTypes.string,
      id: PropTypes.string,
      comments: PropTypes.string,
    }),
    styling: propTypeBlockStyling,
    questionNumber: PropTypes.number,
  };

  handleSubmit = (answer) => {
    this.props.onAnswer(convertToPlainAnswer(answer));
  };

  render = () => {
    const {
      block,
      block: { clientUuid, required, content },
      answer,
      layout,
      styling,
      questionNumber,
      isCloned,
      isInPreviewMode = false,
    } = this.props;

    const isConditionalQuestion = !!(block.logic && block.logic.message);

    return (
      <div>
        {isInPreviewMode &&
          isConditionalQuestion && <ConditionalQuestionLabel enableMessage={block.logic.message} />}
        <TextQuestionRichText
          questionNumber={questionNumber}
          content={content}
          required={required}
          layout={layout}
          styling={styling}
        />
        <DropdownQuestionForm
          layout={layout}
          form={generateQuestionFormName(clientUuid, isCloned)}
          block={block}
          onSubmit={this.handleSubmit}
          initialValues={convertFromPlainAnswer(answer)}
          styling={styling}
        />
      </div>
    );
  };
}

export default DropdownQuestion;
